import { StorageKeys } from './Storage.constants';
import { IStorage } from './Storage.types';

export class AppleStorage implements IStorage {
  constructor() {}

  getItem(key: StorageKeys): string | null {
    throw new Error('Not implemented');
  }

  setItem(key: StorageKeys, value: string): void {
    throw new Error('Not implemented');
  }

  removeItem(key: StorageKeys): void {
    throw new Error('Not implemented');
  }
}
